import { render } from "./CreateBucket.vue?vue&type=template&id=6e8f6e24&scoped=true"
import script from "./CreateBucket.vue?vue&type=script&lang=js"
export * from "./CreateBucket.vue?vue&type=script&lang=js"

import "./CreateBucket.vue?vue&type=style&index=0&id=6e8f6e24&lang=scss&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8f6e24"]])

export default __exports__